import { title } from "@/@core/utils/filter";

export default [
  {
    title: 'Supplier',
    route: 'supplier.index',
    icon: 'BoxIcon',
  },
  {
    title: 'Transaction History',
    icon: 'BookOpenIcon',
    refName: 'notificationTransactionHistory',
    tag: '!',
    tagVariant: 'light-danger',
    children: [
      {
        title: 'Renewals',
        route: 'transaction-history.renewals',
        refName: 'notificationRenewals',
        tag: '0',
        tagVariant: 'light-danger',
      },
      {
        title: 'Credits',
        route: 'transaction-history.credits',
        refName: 'notificationCredits',
        tag: '0',
        tagVariant: 'light-danger',
      },
    ],
  },
  // {
  //   title: 'Transaction History',
  //   route: 'transaction-history.index',
  //   icon: 'BookOpenIcon',
  // },
  {
    title: 'Customer',
    route: 'customer.index',
    icon: 'UserIcon',
  },
  {
    title: 'Berlangganan',
    route: 'subscription.index',
    icon: 'FilePlusIcon',
  },
  // {
  //   title: 'Master Produk',
  //   route: 'master.product.index',
  //   icon: 'HardDriveIcon',
  // },
  {
    title: 'Bank',
    route: 'master-bank.index',
    icon: 'CreditCardIcon',
  },
  // {
  //   title: 'Career',
  //   route: 'career.index',
  // },
  // {
  //   title: 'Contact Us',
  //   route: 'contact_us.index',
  // },
  {
    title: 'Master',
    icon: 'DatabaseIcon',
    children: [
      {
        title: 'Master Provinsi',
        route: 'master.provinces',
      },
      {
        title: 'Master Kabupaten/Kota',
        route: 'master.cities',
      },
      {
        title: 'Master Kecamatan',
        route: 'master.districts',
      },
      {
        title: 'Master Kelurahan',
        route: 'master.subdistricts',
      },
      {
        title: 'Master Area',
        route: 'master.areas',
      },
      {
        title: 'Master Sales',
        route: 'master.sales',
      },
    ],
  },
  {
    title: 'Admin Users',
    route: 'master-admin.index',
    icon: 'DatabaseIcon',
  },
];
